import { API_BASE_URL } from '../config/api';

export interface PrivacyLinkProfile {
  // 'pending' = form can be filled; 'already_submitted' = consent already on
  // file → the page shows a friendly confirmation instead of "Link ungültig".
  // Optional because older backend responses did not carry the field.
  status?: 'pending' | 'already_submitted';
  business_name: string | null;
  privacy_policy_url: string | null;
  first_name: string | null;
  last_name: string | null;
  gender: string | null;
  dpl_accepted: boolean;
  expires_at: string;
}

export interface PrivacyLinkSubmitPayload {
  first_name: string;
  last_name: string;
  gender: string | null;
  dpl_accepted: boolean;
}

export class PrivacyLinkError extends Error {
  status: number;
  detail: string;

  constructor(status: number, detail: string) {
    super(detail);
    this.status = status;
    this.detail = detail;
    this.name = 'PrivacyLinkError';
  }
}

async function parseError(response: Response): Promise<PrivacyLinkError> {
  let detail = `HTTP ${response.status}`;
  try {
    const body = await response.json();
    if (body?.detail) detail = String(body.detail);
  } catch {
    /* ignore */
  }
  return new PrivacyLinkError(response.status, detail);
}

export async function fetchPrivacyLink(token: string): Promise<PrivacyLinkProfile> {
  const response = await fetch(`${API_BASE_URL}/privacy-link/${encodeURIComponent(token)}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) throw await parseError(response);
  return response.json();
}

export async function submitPrivacyLink(
  token: string,
  payload: PrivacyLinkSubmitPayload,
): Promise<{ ok: boolean }> {
  const response = await fetch(`${API_BASE_URL}/privacy-link/${encodeURIComponent(token)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw await parseError(response);
  return response.json();
}
